export default __webpack_public_path__ + "static/media/arrow-email.94b9abcf.png";